<template>
  <v-app :class="[colorApp, { '__loading-axios': getLoadingAxiosState }]">
    <loading />
    <loading-axios />
    <template v-if="statusOrder.indexOf(this.$route.name) === -1">
      <appbar />
      <menubar />
    </template>
    <v-main :class="[`_content white`]" style="padding: 56px 0px 0px;">
      <router-view />
    </v-main>
    <v-bottom-sheet v-model="$store.state.block_tooLong" persistent :content-class="'__sheet-top-rounded'">
      <v-sheet style="height: 100%">
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <h5 class="title mb-3 text-center" v-html="$t('too_far_from_restaurant')" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <div class="text-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="239.321" height="163.428" viewBox="0 0 239.321 163.428" class="navigator_too_long--img">
                  <defs />
                  <g transform="translate(23.772 28.339)">
                    <path class="a" d="M175.214,83.571c-15.342-.543-29.953-5.6-43.907-11.127S103.532,60.789,88.555,57.86c-9.63-1.886-20.646-2.152-28.407,3.117C52.68,66.047,50.268,74.8,48.97,82.921c-.976,6.111-1.549,12.54,1.124,18.262,1.856,3.97,5.153,7.308,7.426,11.112,7.933,13.237,2.334,29.557-6.272,42.483-4.031,6.061-8.711,11.846-11.822,18.3s-4.545,13.848-1.81,20.442c2.7,6.525,9.123,11.426,16.1,14.874,14.139,6.99,30.813,8.995,47.071,10.129,35.991,2.511,72.176,1.424,108.263.336,13.354-.4,26.769-.812,39.906-2.92,7.3-1.169,14.828-3.031,20.126-7.51,6.723-5.691,8.391-15.329,3.885-22.466-7.557-11.971-28.453-14.937-33.734-27.791-2.909-7.07.078-14.948,4.3-21.5,9.064-14.071,24.257-26.41,25.057-42.492.552-11.04-6.753-22.106-18.047-27.332-11.839-5.477-28.252-4.788-36.987,4.28C204.564,80.458,188.76,84.049,175.214,83.571Z" transform="translate(-59.939 -84.963)" />
                    <circle class="b" cx="11.162" cy="11.162" r="11.162" transform="translate(38.238 9.509)" />
                    <path class="c" d="M353.412,301.39H298.654a1.116,1.116,0,0,1-.2-.016l25.9-44.859a1.813,1.813,0,0,1,3.156,0l17.381,30.1.833,1.44Z" transform="translate(-269.009 -246.321)" />
                    <path class="d" d="M325.254,207.273h-18.7l9.178-13.331.661-.96.33-.48.833,1.44Z" transform="translate(-240.851 -152.205)" />
                    <path class="c" d="M519.036,348.295H471.675l9.178-13.331.66-.96,11.959-17.373a2.42,2.42,0,0,1,3.592-.215,2.169,2.169,0,0,1,.172.215Z" transform="translate(-404.144 -293.226)" />
                    <circle class="e" cx="3.363" cy="3.363" r="3.363" transform="translate(125.43 40.962)" />
                    <path class="c" d="M592.494,219.154H591.8l.314-10.638Z" transform="translate(-463.376 -164.698)" />
                    <path class="c" d="M593.186,214.054l.74-1.023-.75,1.277-.081-.142Z" transform="translate(-464.382 -168.22)" />
                    <path class="c" d="M590.517,218.754l-.74-1.023.75,1.276.081-.142Z" transform="translate(-461.794 -171.886)" />
                    <circle class="e" cx="3.363" cy="3.363" r="3.363" transform="translate(156.284 40.962)" />
                    <path class="c" d="M732.81,219.154h-.689l.314-10.638Z" transform="translate(-572.838 -164.698)" />
                    <path class="c" d="M733.5,214.054l.74-1.023-.75,1.277-.081-.142Z" transform="translate(-573.844 -168.22)" />
                    <path class="c" d="M730.834,218.754l-.74-1.023.75,1.276.081-.142Z" transform="translate(-571.257 -171.886)" />
                    <circle class="e" cx="4.968" cy="4.968" r="4.968" transform="translate(133.57 34.526)" />
                    <path class="c" d="M636.342,201.155h-1.017l.464-15.711Z" transform="translate(-497.326 -146.699)" />
                    <path class="c" d="M637.365,193.624l1.092-1.511L637.35,194l-.12-.21Z" transform="translate(-498.812 -151.901)" />
                    <path class="c" d="M633.423,200.565l-1.092-1.511,1.107,1.885.12-.209Z" transform="translate(-494.991 -157.316)" />
                    <circle class="e" cx="4.968" cy="4.968" r="4.968" transform="translate(145.684 34.526)" />
                    <path class="c" d="M691.436,201.155h-1.017l.464-15.711Z" transform="translate(-540.306 -146.699)" />
                    <path class="c" d="M692.459,193.624l1.092-1.511L692.444,194l-.12-.21Z" transform="translate(-541.792 -151.901)" />
                    <path class="c" d="M688.516,200.565l-1.092-1.511,1.107,1.885.12-.209Z" transform="translate(-537.969 -157.316)" />
                    <circle class="e" cx="4.968" cy="4.968" r="4.968" transform="translate(114.263 34.526)" />
                    <path class="c" d="M548.536,201.155h-1.017l.464-15.711Z" transform="translate(-428.828 -146.699)" />
                    <path class="c" d="M549.56,193.624l1.092-1.511L549.545,194l-.12-.21Z" transform="translate(-430.315 -151.901)" />
                    <path class="c" d="M545.617,200.565l-1.092-1.511,1.107,1.885.12-.209Z" transform="translate(-426.492 -157.316)" />
                    <path class="f" d="M343.742,509.051H181.627a15.553,15.553,0,1,1,0-31.107H343.384a5.982,5.982,0,1,0,0-11.964H176.244v-9.571h167.14a15.553,15.553,0,0,1,0,31.107H181.627a5.982,5.982,0,1,0,0,11.964H343.742Z" transform="translate(-165.741 -402.979)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(16.485 57.976)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(37.542 57.976)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(58.599 57.976)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(79.656 57.976)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(100.713 57.976)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(121.77 57.976)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(142.827 57.976)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(163.884 57.976)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(16.485 79.511)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(37.542 79.511)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(58.599 79.511)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(79.656 79.511)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(100.713 79.511)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(121.77 79.511)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(142.827 79.511)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(163.884 79.511)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(16.485 101.047)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(37.542 101.047)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(58.599 101.047)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(79.656 101.047)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(100.713 101.047)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(121.77 101.047)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(142.827 101.047)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(163.884 101.047)" />
                    <path class="h" d="M727.294,294.43a6.375,6.375,0,0,0-1.329-1.254h2.776A4.644,4.644,0,0,0,727.294,294.43Z" transform="translate(-602.519 -275.639)" />
                    <path class="h" d="M690.743,293.176h.479c-.1.072-.206.144-.3.222C690.861,293.322,690.8,293.25,690.743,293.176Z" transform="translate(-575.042 -275.639)" />
                    <path class="i" d="M740.811,290.559a4.581,4.581,0,0,1,2.227.576h-4.449A4.561,4.561,0,0,1,740.811,290.559Z" transform="translate(-612.367 -273.598)" />
                    <path class="i" d="M696.55,287.941a6.294,6.294,0,0,1,3.636,1.151h-7.266A6.292,6.292,0,0,1,696.55,287.941Z" transform="translate(-576.74 -271.555)" />
                    <path class="i" d="M486.988,215.311a11.8,11.8,0,0,1,23.148-2.488c.143-.005.286-.011.43-.011a11.8,11.8,0,0,1,11.32,8.472,8.338,8.338,0,0,1,9.895,2.463h-36.8a7.98,7.98,0,0,1-8-8.263Q486.984,215.4,486.988,215.311Z" transform="translate(-416.08 -206.212)" />
                    <path class="h" d="M772.455,333.606a6.376,6.376,0,0,1,1.329-1.254h-2.776A4.642,4.642,0,0,1,772.455,333.606Z" transform="translate(-637.658 -306.201)" />
                    <path class="h" d="M817.156,332.352h-.479c.1.072.206.144.3.222C817.038,332.5,817.1,332.426,817.156,332.352Z" transform="translate(-673.286 -306.201)" />
                    <path class="i" d="M753,329.734a4.581,4.581,0,0,0-2.227.576h4.449A4.561,4.561,0,0,0,753,329.734Z" transform="translate(-621.875 -304.159)" />
                    <path class="i" d="M787.268,327.117a6.294,6.294,0,0,0-3.636,1.151H790.9A6.293,6.293,0,0,0,787.268,327.117Z" transform="translate(-647.506 -302.117)" />
                    <path class="i" d="M863.646,254.488A11.8,11.8,0,0,0,840.5,252c-.143-.005-.286-.011-.43-.011a11.8,11.8,0,0,0-11.32,8.472,8.338,8.338,0,0,0-9.894,2.463h36.8a7.981,7.981,0,0,0,8-8.263Q863.651,254.575,863.646,254.488Z" transform="translate(-674.983 -236.773)" />
                    <rect class="c" width="4.277" height="0.679" transform="matrix(-1, -0.001, 0.001, -1, 168.404, 99.386)" />
                    <path class="e" d="M770.332,604.055l.883.2,33.54.018.3-.7a7.093,7.093,0,0,0,.521-3.835,2.984,2.984,0,0,0-1.329-2.354l-1.488-9.913-18.556-.033-7.179,5.791s-3.387-.061-5.226,2.23a5.376,5.376,0,0,0-1.125,2.961l-.073,1.192Z" transform="translate(-637.13 -505.198)" />
                    <circle class="c" cx="4.142" cy="4.142" r="4.142" transform="translate(136.426 94.55)" />
                    <circle class="j" cx="2.18" cy="2.18" r="2.18" transform="translate(138.388 96.512)" />
                    <circle class="c" cx="4.142" cy="4.142" r="4.142" transform="translate(156.863 94.561)" />
                    <circle class="j" cx="2.18" cy="2.18" r="2.18" transform="translate(158.825 96.523)" />
                    <path class="g" d="M656.92,392.306l10.019,0h1.223l2.065,0v-.151l0-1.816v-2.039h-2.6l-2.166,0h-1.223l-2.5,0Z" transform="translate(-514.173 -304.951)" />
                    <path class="g" d="M724.849,392.334l5.295,0v-4.005h-.775l-1.223,0h-3.3Z" transform="translate(-567.165 -304.972)" />
                    <rect class="c" width="0.679" height="1.29" transform="matrix(-1, -0.001, 0.001, -1, 156.051, 91.64)" />
                    <rect class="c" width="0.679" height="1.29" transform="matrix(-0.001, 1, -1, -0.001, 145.463, 88.511)" />
                    <path class="c" d="M0,0H.075A1.419,1.419,0,0,1,1.494,1.419h0A1.419,1.419,0,0,1,.075,2.838H0Z" transform="matrix(-1, -0.001, 0.001, -1, 144.986, 88.809)" />
                    <path class="c" d="M771.559,628.065a2.193,2.193,0,0,0,1.2-4.153,5.375,5.375,0,0,0-1.125,2.961Z" transform="translate(-638.088 -533.651)" />
                    <path class="k" d="M705.639,388.316l2.594,3.856,0-1.816-1.372-2.039Z" transform="translate(-552.179 -304.962)" />
                    <path class="k" d="M739.854,388.335l2,2.968v-1.816l-.774-1.15Z" transform="translate(-578.871 -304.977)" />
                    <path class="k" d="M690.225,388.309l2.7,4.007h1.223l-2.7-4.007Z" transform="translate(-540.154 -304.956)" />
                    <circle class="c" cx="11.007" cy="11.007" r="11.007" transform="translate(-1.701 44.337)" />
                    <path class="e" d="M186.554,416.643l-5.508-5.508a.957.957,0,1,1,1.354-1.354l4.063,4.063,12.965-14.785a.957.957,0,0,1,1.439,1.262Z" transform="translate(-177.202 -357.986)" />
                  </g>
                </svg>
              </div>
              <!-- <v-img src="@/assets/images/svg/navigator_too_long.svg" contain /> -->
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <p class="subtitle-2 text-center my-3">
                {{ $t('max_radius_message', { maxRadius: '250m' }) }}
              </p>
              <v-btn type="submit" color="primary" block x-large rounded class="text-none" @click="goBackHome()">
                {{ $t('back') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="$store.state.outside_radius" persistent :content-class="'__sheet-top-rounded'">
      <v-sheet style="height: 100%">
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <h5 class="title mb-3 text-center" v-html="$t('too_far_from_restaurant')" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <div class="text-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="239.321" height="163.428" viewBox="0 0 239.321 163.428" class="navigator_too_long--img">
                  <defs />
                  <g transform="translate(23.772 28.339)">
                    <path class="a" d="M175.214,83.571c-15.342-.543-29.953-5.6-43.907-11.127S103.532,60.789,88.555,57.86c-9.63-1.886-20.646-2.152-28.407,3.117C52.68,66.047,50.268,74.8,48.97,82.921c-.976,6.111-1.549,12.54,1.124,18.262,1.856,3.97,5.153,7.308,7.426,11.112,7.933,13.237,2.334,29.557-6.272,42.483-4.031,6.061-8.711,11.846-11.822,18.3s-4.545,13.848-1.81,20.442c2.7,6.525,9.123,11.426,16.1,14.874,14.139,6.99,30.813,8.995,47.071,10.129,35.991,2.511,72.176,1.424,108.263.336,13.354-.4,26.769-.812,39.906-2.92,7.3-1.169,14.828-3.031,20.126-7.51,6.723-5.691,8.391-15.329,3.885-22.466-7.557-11.971-28.453-14.937-33.734-27.791-2.909-7.07.078-14.948,4.3-21.5,9.064-14.071,24.257-26.41,25.057-42.492.552-11.04-6.753-22.106-18.047-27.332-11.839-5.477-28.252-4.788-36.987,4.28C204.564,80.458,188.76,84.049,175.214,83.571Z" transform="translate(-59.939 -84.963)" />
                    <circle class="b" cx="11.162" cy="11.162" r="11.162" transform="translate(38.238 9.509)" />
                    <path class="c" d="M353.412,301.39H298.654a1.116,1.116,0,0,1-.2-.016l25.9-44.859a1.813,1.813,0,0,1,3.156,0l17.381,30.1.833,1.44Z" transform="translate(-269.009 -246.321)" />
                    <path class="d" d="M325.254,207.273h-18.7l9.178-13.331.661-.96.33-.48.833,1.44Z" transform="translate(-240.851 -152.205)" />
                    <path class="c" d="M519.036,348.295H471.675l9.178-13.331.66-.96,11.959-17.373a2.42,2.42,0,0,1,3.592-.215,2.169,2.169,0,0,1,.172.215Z" transform="translate(-404.144 -293.226)" />
                    <circle class="e" cx="3.363" cy="3.363" r="3.363" transform="translate(125.43 40.962)" />
                    <path class="c" d="M592.494,219.154H591.8l.314-10.638Z" transform="translate(-463.376 -164.698)" />
                    <path class="c" d="M593.186,214.054l.74-1.023-.75,1.277-.081-.142Z" transform="translate(-464.382 -168.22)" />
                    <path class="c" d="M590.517,218.754l-.74-1.023.75,1.276.081-.142Z" transform="translate(-461.794 -171.886)" />
                    <circle class="e" cx="3.363" cy="3.363" r="3.363" transform="translate(156.284 40.962)" />
                    <path class="c" d="M732.81,219.154h-.689l.314-10.638Z" transform="translate(-572.838 -164.698)" />
                    <path class="c" d="M733.5,214.054l.74-1.023-.75,1.277-.081-.142Z" transform="translate(-573.844 -168.22)" />
                    <path class="c" d="M730.834,218.754l-.74-1.023.75,1.276.081-.142Z" transform="translate(-571.257 -171.886)" />
                    <circle class="e" cx="4.968" cy="4.968" r="4.968" transform="translate(133.57 34.526)" />
                    <path class="c" d="M636.342,201.155h-1.017l.464-15.711Z" transform="translate(-497.326 -146.699)" />
                    <path class="c" d="M637.365,193.624l1.092-1.511L637.35,194l-.12-.21Z" transform="translate(-498.812 -151.901)" />
                    <path class="c" d="M633.423,200.565l-1.092-1.511,1.107,1.885.12-.209Z" transform="translate(-494.991 -157.316)" />
                    <circle class="e" cx="4.968" cy="4.968" r="4.968" transform="translate(145.684 34.526)" />
                    <path class="c" d="M691.436,201.155h-1.017l.464-15.711Z" transform="translate(-540.306 -146.699)" />
                    <path class="c" d="M692.459,193.624l1.092-1.511L692.444,194l-.12-.21Z" transform="translate(-541.792 -151.901)" />
                    <path class="c" d="M688.516,200.565l-1.092-1.511,1.107,1.885.12-.209Z" transform="translate(-537.969 -157.316)" />
                    <circle class="e" cx="4.968" cy="4.968" r="4.968" transform="translate(114.263 34.526)" />
                    <path class="c" d="M548.536,201.155h-1.017l.464-15.711Z" transform="translate(-428.828 -146.699)" />
                    <path class="c" d="M549.56,193.624l1.092-1.511L549.545,194l-.12-.21Z" transform="translate(-430.315 -151.901)" />
                    <path class="c" d="M545.617,200.565l-1.092-1.511,1.107,1.885.12-.209Z" transform="translate(-426.492 -157.316)" />
                    <path class="f" d="M343.742,509.051H181.627a15.553,15.553,0,1,1,0-31.107H343.384a5.982,5.982,0,1,0,0-11.964H176.244v-9.571h167.14a15.553,15.553,0,0,1,0,31.107H181.627a5.982,5.982,0,1,0,0,11.964H343.742Z" transform="translate(-165.741 -402.979)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(16.485 57.976)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(37.542 57.976)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(58.599 57.976)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(79.656 57.976)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(100.713 57.976)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(121.77 57.976)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(142.827 57.976)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(163.884 57.976)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(16.485 79.511)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(37.542 79.511)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(58.599 79.511)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(79.656 79.511)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(100.713 79.511)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(121.77 79.511)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(142.827 79.511)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(163.884 79.511)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(16.485 101.047)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(37.542 101.047)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(58.599 101.047)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(79.656 101.047)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(100.713 101.047)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(121.77 101.047)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(142.827 101.047)" />
                    <rect class="g" width="7.418" height="0.479" transform="translate(163.884 101.047)" />
                    <path class="h" d="M727.294,294.43a6.375,6.375,0,0,0-1.329-1.254h2.776A4.644,4.644,0,0,0,727.294,294.43Z" transform="translate(-602.519 -275.639)" />
                    <path class="h" d="M690.743,293.176h.479c-.1.072-.206.144-.3.222C690.861,293.322,690.8,293.25,690.743,293.176Z" transform="translate(-575.042 -275.639)" />
                    <path class="i" d="M740.811,290.559a4.581,4.581,0,0,1,2.227.576h-4.449A4.561,4.561,0,0,1,740.811,290.559Z" transform="translate(-612.367 -273.598)" />
                    <path class="i" d="M696.55,287.941a6.294,6.294,0,0,1,3.636,1.151h-7.266A6.292,6.292,0,0,1,696.55,287.941Z" transform="translate(-576.74 -271.555)" />
                    <path class="i" d="M486.988,215.311a11.8,11.8,0,0,1,23.148-2.488c.143-.005.286-.011.43-.011a11.8,11.8,0,0,1,11.32,8.472,8.338,8.338,0,0,1,9.895,2.463h-36.8a7.98,7.98,0,0,1-8-8.263Q486.984,215.4,486.988,215.311Z" transform="translate(-416.08 -206.212)" />
                    <path class="h" d="M772.455,333.606a6.376,6.376,0,0,1,1.329-1.254h-2.776A4.642,4.642,0,0,1,772.455,333.606Z" transform="translate(-637.658 -306.201)" />
                    <path class="h" d="M817.156,332.352h-.479c.1.072.206.144.3.222C817.038,332.5,817.1,332.426,817.156,332.352Z" transform="translate(-673.286 -306.201)" />
                    <path class="i" d="M753,329.734a4.581,4.581,0,0,0-2.227.576h4.449A4.561,4.561,0,0,0,753,329.734Z" transform="translate(-621.875 -304.159)" />
                    <path class="i" d="M787.268,327.117a6.294,6.294,0,0,0-3.636,1.151H790.9A6.293,6.293,0,0,0,787.268,327.117Z" transform="translate(-647.506 -302.117)" />
                    <path class="i" d="M863.646,254.488A11.8,11.8,0,0,0,840.5,252c-.143-.005-.286-.011-.43-.011a11.8,11.8,0,0,0-11.32,8.472,8.338,8.338,0,0,0-9.894,2.463h36.8a7.981,7.981,0,0,0,8-8.263Q863.651,254.575,863.646,254.488Z" transform="translate(-674.983 -236.773)" />
                    <rect class="c" width="4.277" height="0.679" transform="matrix(-1, -0.001, 0.001, -1, 168.404, 99.386)" />
                    <path class="e" d="M770.332,604.055l.883.2,33.54.018.3-.7a7.093,7.093,0,0,0,.521-3.835,2.984,2.984,0,0,0-1.329-2.354l-1.488-9.913-18.556-.033-7.179,5.791s-3.387-.061-5.226,2.23a5.376,5.376,0,0,0-1.125,2.961l-.073,1.192Z" transform="translate(-637.13 -505.198)" />
                    <circle class="c" cx="4.142" cy="4.142" r="4.142" transform="translate(136.426 94.55)" />
                    <circle class="j" cx="2.18" cy="2.18" r="2.18" transform="translate(138.388 96.512)" />
                    <circle class="c" cx="4.142" cy="4.142" r="4.142" transform="translate(156.863 94.561)" />
                    <circle class="j" cx="2.18" cy="2.18" r="2.18" transform="translate(158.825 96.523)" />
                    <path class="g" d="M656.92,392.306l10.019,0h1.223l2.065,0v-.151l0-1.816v-2.039h-2.6l-2.166,0h-1.223l-2.5,0Z" transform="translate(-514.173 -304.951)" />
                    <path class="g" d="M724.849,392.334l5.295,0v-4.005h-.775l-1.223,0h-3.3Z" transform="translate(-567.165 -304.972)" />
                    <rect class="c" width="0.679" height="1.29" transform="matrix(-1, -0.001, 0.001, -1, 156.051, 91.64)" />
                    <rect class="c" width="0.679" height="1.29" transform="matrix(-0.001, 1, -1, -0.001, 145.463, 88.511)" />
                    <path class="c" d="M0,0H.075A1.419,1.419,0,0,1,1.494,1.419h0A1.419,1.419,0,0,1,.075,2.838H0Z" transform="matrix(-1, -0.001, 0.001, -1, 144.986, 88.809)" />
                    <path class="c" d="M771.559,628.065a2.193,2.193,0,0,0,1.2-4.153,5.375,5.375,0,0,0-1.125,2.961Z" transform="translate(-638.088 -533.651)" />
                    <path class="k" d="M705.639,388.316l2.594,3.856,0-1.816-1.372-2.039Z" transform="translate(-552.179 -304.962)" />
                    <path class="k" d="M739.854,388.335l2,2.968v-1.816l-.774-1.15Z" transform="translate(-578.871 -304.977)" />
                    <path class="k" d="M690.225,388.309l2.7,4.007h1.223l-2.7-4.007Z" transform="translate(-540.154 -304.956)" />
                    <circle class="c" cx="11.007" cy="11.007" r="11.007" transform="translate(-1.701 44.337)" />
                    <path class="e" d="M186.554,416.643l-5.508-5.508a.957.957,0,1,1,1.354-1.354l4.063,4.063,12.965-14.785a.957.957,0,0,1,1.439,1.262Z" transform="translate(-177.202 -357.986)" />
                  </g>
                </svg>
              </div>
              <!-- <v-img src="@/assets/images/svg/navigator_too_long.svg" contain /> -->
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <p class="subtitle-2 text-center my-3">
                {{ $t('max_radius_message', { maxRadius: $store.state.selected_outlet !== null ? $store.state.selected_outlet.delivery.max_radius_delivery + 'km' : $store.state.selected_store.delivery.max_radius_delivery + 'km' }) }}
              </p>
              <v-btn type="submit" color="primary" block x-large rounded class="text-none" @click="closeSheetOutsideRadius()">
                {{ $t('back') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="$store.state.block_location" persistent :content-class="'__sheet-top-rounded'">
      <v-sheet style="height: 100%">
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <template v-if="$store.state.must_allow_location !== true">
                <v-btn text icon color="red lighten-2" @click="closeSheetNoAccessGPS()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </template>
              <div class="d-flex justify-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="239.321" height="166.182" viewBox="0 0 239.321 166.182" class="access_gps--img">
                  <defs />
                  <g transform="translate(-2708.667 -1907.811)">
                    <g transform="translate(2708.667 1907.811)">
                      <path class="a" d="M175.214,81.725c-15.342-.506-29.953-5.215-43.907-10.365S103.532,60.5,88.555,57.775c-9.63-1.756-20.646-2-28.407,2.9C52.68,65.4,50.268,73.554,48.97,81.12c-.976,5.692-1.549,11.681,1.124,17.011,1.856,3.7,5.153,6.808,7.426,10.35,7.933,12.331,2.334,27.533-6.272,39.573-4.031,5.646-8.711,11.034-11.822,17.045s-4.545,12.9-1.81,19.041c2.7,6.078,9.123,10.643,16.1,13.855,14.139,6.511,30.813,8.378,47.071,9.435,35.991,2.339,72.176,1.327,108.263.313,13.354-.377,26.769-.756,39.906-2.72,7.3-1.089,14.828-2.823,20.126-7,6.723-5.3,8.391-14.279,3.885-20.927-7.557-11.151-28.453-13.914-33.734-25.887-2.909-6.586.078-13.924,4.3-20.032,9.064-13.107,24.257-24.6,25.057-39.581.552-10.284-6.753-20.592-18.047-25.46-11.839-5.1-28.252-4.46-36.987,3.987C204.564,78.825,188.76,82.17,175.214,81.725Z" transform="translate(-36.167 -42.675)" />
                      <path class="b" d="M295.685,610.194s113.842-33.68,112.609-68.607c-2.26-9.656-17.875-12.122-17.875-12.122s-36.982-4.931-16.847-16.847,75.2-9.04,75.2-9.04-56.705,9.04-31.64,13.971c20.134,1.233,46.021,6.575,46.021,6.575s52.6,11.095,59.993,38.214,1.233,48.076,1.233,48.076Z" transform="translate(-294.842 -472.084)" />
                    </g>
                    <path class="c" d="M617.994,758.405l-.485-.677q1.027-.734,2.023-1.461l.49.673Q619.022,757.668,617.994,758.405Z" transform="translate(2216.9 1288.074)" />
                    <path class="d" d="M582.892,609.527l-.5-.664c1.346-1.019,2.671-2.044,3.939-3.047l.516.653C585.571,607.476,584.242,608.5,582.892,609.527Zm7.838-6.2-.532-.641c1.3-1.082,2.576-2.169,3.785-3.231l.55.625c-1.215,1.068-2.495,2.16-3.8,3.247Zm7.508-6.608-.57-.607c1.243-1.166,2.441-2.333,3.562-3.469l.593.585c-1.128,1.144-2.335,2.319-3.585,3.492Zm7.02-7.137-.62-.556c1.142-1.272,2.222-2.546,3.21-3.786l.651.519c-1,1.253-2.089,2.539-3.242,3.823Zm6.226-7.856-.688-.469c.968-1.419,1.842-2.835,2.6-4.209l.73.4C613.354,578.843,612.466,580.282,611.483,581.723Zm4.788-8.833-.775-.3a28.892,28.892,0,0,0,1.414-4.7l.816.168a29.658,29.658,0,0,1-1.454,4.837Zm1.112-9.867a19.616,19.616,0,0,0-.67-4.791l.8-.217a20.478,20.478,0,0,1,.7,4.995Zm-2.491-9.286a25.108,25.108,0,0,0-2.772-4.024l.638-.534a25.931,25.931,0,0,1,2.863,4.158Zm-6.212-7.538a45.134,45.134,0,0,0-3.883-3.059l.481-.68a45.852,45.852,0,0,1,3.955,3.116Zm-8.056-5.739c-1.362-.8-2.832-1.6-4.367-2.375l.375-.743c1.551.783,3.036,1.59,4.414,2.4Zm-8.868-4.5c-1.45-.644-2.994-1.292-4.589-1.927l.308-.773c1.605.638,3.159,1.291,4.619,1.939Zm-9.259-3.7c-1.484-.538-3.07-1.09-4.714-1.641l.264-.79c1.65.553,3.243,1.108,4.733,1.648Zm-9.465-3.184c-1.451-.458-3.013-.94-4.776-1.474l.242-.8c1.766.535,3.331,1.018,4.785,1.476Zm-9.568-2.912c-1.685-.5-3.291-.985-4.794-1.448l.245-.8c1.5.463,3.105.944,4.788,1.447Zm-9.57-2.993a39.584,39.584,0,0,1-4.69-1.888l.374-.744a38.629,38.629,0,0,0,4.588,1.845Zm2.737-8.917-.2-.808c1.44-.359,3.081-.734,4.877-1.115l.173.815c-1.786.379-3.417.752-4.848,1.109Zm9.731-2.09-.156-.818c1.534-.293,3.187-.6,4.912-.9l.146.82c-1.722.306-3.37.608-4.9.9Zm9.814-1.747-.137-.821q2.354-.395,4.926-.807l.132.822Q578.526,510.023,576.176,510.417Z" transform="translate(2258.044 1432.508)" />
                    <g transform="translate(2731 1519)">
                      <rect class="e" width="6" height="30" transform="translate(102 455)" />
                      <rect class="e" width="6" height="30" transform="translate(162 455)" />
                      <g class="f" transform="translate(90 436)">
                        <rect class="k" width="90" height="32" rx="3" />
                        <rect class="l" x="1" y="1" width="88" height="30" rx="2" />
                      </g>
                      <text class="g" transform="translate(135.282 456.723)">
                        <tspan x="-32.69" y="0">
                          {{ $t('no_access') }}
                        </tspan>
                      </text>
                    </g>
                    <circle class="h" cx="26.906" cy="26.906" r="26.906" transform="translate(2758.247 1907.811)" />
                    <path class="i" d="M558.68,255.443h.074l1.331,76.283h-2.809Z" transform="translate(2226.547 1679.274)" />
                    <rect class="i" width="1.331" height="5.026" transform="translate(2789.505 1975.091) rotate(62.234)" />
                    <path class="j" d="M713.227,358.887a26.908,26.908,0,0,1-44.833,28.477,26.908,26.908,0,1,0,44.833-28.477Z" transform="translate(2091.939 1557.859)" />
                  </g>
                </svg>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <h5 class="title mb-3 text-center">
                {{ $t('gps_access_denied') }}
              </h5>
              <p class="subtitle-2 text-center my-3">
                {{ $t('gps_activation_instruction') }}
              </p>
              <v-btn type="submit" color="primary" block x-large rounded class="text-none" @click="goLearnMore()">
                {{ $t('learn_more') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
    <v-bottom-sheet v-model="$store.state.block_camera" persistent :content-class="'__sheet-top-rounded'">
      <v-sheet style="height: 100%">
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <v-btn text icon color="red lighten-2" @click="closeSheetNoAccessCamera()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <div class="text-center">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="239.321" height="171.435" viewBox="0 0 239.321 171.435" class="access_camera--img">
                  <defs>
                    <filter id="a" x="104.053" y="69.135" width="104.909" height="56.384" filterUnits="userSpaceOnUse">
                      <feOffset dy="3" input="SourceAlpha" />
                      <feGaussianBlur stdDeviation="3" result="b" />
                      <feFlood flood-opacity="0.161" />
                      <feComposite operator="in" in2="b" />
                      <feComposite in="SourceGraphic" />
                    </filter>
                  </defs>
                  <g transform="translate(-2721.667 -1651.565)">
                    <path class="a" d="M175.214,83.571c-15.342-.543-29.953-5.6-43.907-11.127S103.532,60.789,88.555,57.86c-9.63-1.886-20.646-2.152-28.407,3.117C52.68,66.047,50.268,74.8,48.97,82.921c-.976,6.111-1.549,12.54,1.124,18.262,1.856,3.97,5.153,7.308,7.426,11.112,7.933,13.237,2.334,29.557-6.272,42.483-4.031,6.061-8.711,11.846-11.822,18.3s-4.545,13.848-1.81,20.442c2.7,6.525,9.123,11.426,16.1,14.874,14.139,6.99,30.813,8.995,47.071,10.129,35.991,2.511,72.176,1.424,108.263.336,13.354-.4,26.769-.812,39.906-2.92,7.3-1.169,14.828-3.031,20.126-7.51,6.723-5.691,8.391-15.329,3.885-22.466-7.557-11.971-28.453-14.937-33.734-27.791-2.909-7.07.078-14.948,4.3-21.5,9.064-14.071,24.257-26.41,25.057-42.492.552-11.04-6.753-22.106-18.047-27.332-11.839-5.477-28.252-4.788-36.987,4.28C204.564,80.458,188.76,84.049,175.214,83.571Z" transform="translate(2685.5 1594.94)" />
                    <ellipse class="b" cx="88" cy="15" rx="88" ry="15" transform="translate(2753 1775)" />
                    <g class="c" transform="translate(2748 1678)">
                      <rect class="k" width="186" height="111" rx="10" />
                      <rect class="l" x="1.5" y="1.5" width="183" height="108" rx="8.5" />
                    </g>
                    <g transform="translate(2721.667 1651.565)">
                      <circle class="d" cx="41.5" cy="41.5" r="41.5" transform="translate(51.333 39.435)" />
                      <path class="d" d="M6,0H34a6,6,0,0,1,6,6V6a0,0,0,0,1,0,0H0A0,0,0,0,1,0,6V6A6,6,0,0,1,6,0Z" transform="translate(46.333 20.435)" />
                    </g>
                    <circle class="e" cx="31.5" cy="31.5" r="31.5" transform="translate(2783 1701)" />
                    <rect class="f" width="32" height="14" rx="6" transform="translate(2859 1691)" />
                    <g transform="translate(2834.72 1696.325)">
                      <line class="g" y1="36.348" x2="21.479" transform="translate(21.976 2.478)" />
                      <line class="g" x1="21.479" y1="31.392" transform="translate(43.455 2.478)" />
                      <g class="h" transform="translate(39.28 -0.325)">
                        <circle class="k" cx="3.5" cy="3.5" r="3.5" />
                        <circle class="l" cx="3.5" cy="3.5" r="3" />
                      </g>
                      <g transform="matrix(0.995, -0.105, 0.105, 0.995, 0, 39.182)">
                        <g class="m" transform="matrix(0.99, 0.1, -0.1, 0.99, -103.66, -95.3)">
                          <g class="i" transform="matrix(0.99, -0.1, 0.1, 0.99, 113.05, 83.94)">
                            <rect class="k" width="84.262" height="29.74" rx="2" />
                            <rect class="l" x="1" y="1" width="82.262" height="27.74" rx="1" />
                          </g>
                        </g>
                        <text class="j" transform="translate(41.261 19.609)">
                          <tspan x="-32.69" y="0">
                            {{ $t('no_access') }}
                          </tspan>
                        </text>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <h5 class="title mb-3 text-center">
                {{ $t('camera_access_denied') }}
              </h5>
              <p class="subtitle-2 text-center my-3">
                {{ $t('camera_access_unavailable') }}
              </p>
              <v-btn type="submit" color="primary" block x-large rounded class="text-none" @click="goLearnMore()">
                {{ $t('learn_more') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
    <v-snackbar v-model="snackWithButtons" :timeout="timeout" bottom left>
      {{ $t('new_version_available') }}
      <v-spacer />
      <v-btn dark text color="#00f500" @click.native="refreshApp">
        {{ $t('refresh') }}
      </v-btn>
      <v-btn dark icon @click="snackWithButtons = false">
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>
    </v-snackbar>
    <errorMessages v-if="showError" />
  </v-app>
</template>

<script>
import '@/assets/sass/variables.sass'
import { mapGetters } from 'vuex'
import appbar from '@/components/modules/menu/AppBar'
import menubar from '@/components/modules/menu/Menubar'
import loading from '@/components/modules/Loading'
import loadingAxios from '@/components/modules/LoadingAxios'
import errorMessages from '@/components/modules/errorMessages'
export default {
  name: 'App',
  components: {
    appbar,
    menubar,
    loading,
    loadingAxios,
    errorMessages
  },
  data() {
    return {
      statusOrder: [
        'order_failed',
        'order_cancelled',
        'order_payment_pending',
        'order_payment_failed',
        'order_success'
      ],
      refreshing: false,
      registration: null,
      snackWithButtons: false,
      timeout: -1,
      title: '',
      favicon: '',
      colorApp: 'theme-1'
    }
  },
  computed: {
    errorType: function() {
      return this.$store.getters.errorType
    },
    errorMessage: function() {
      return this.$store.getters.errorMessage
    },
    showError: function() {
      return this.$store.getters.showError
    },
    ...mapGetters(['getLoadingAxiosState'])
  },
  created() {
    if (!this.$isEmpty(this.$store.state.selected_store)) {
      this.title = this.$store.state.selected_store.name
      this.favicon = this.$store.state.selected_store.website_favicon
      if (this.$store.state.selected_store.setting.online_color_id === 1) {
        this.colorApp = 'theme-1'
      } else if (this.$store.state.selected_store.setting.online_color_id === 2) {
        this.colorApp = 'theme-2'
      } else if (this.$store.state.selected_store.setting.online_color_id === 3) {
        this.colorApp = 'theme-3'
      } else if (this.$store.state.selected_store.setting.online_color_id === 4) {
        this.colorApp = 'theme-4'
      } else if (this.$store.state.selected_store.setting.online_color_id === 5) {
        this.colorApp = 'theme-5'
      } else if (this.$store.state.selected_store.setting.online_color_id === 6) {
        this.colorApp = 'theme-6'
      } else if (this.$store.state.selected_store.setting.online_color_id === 7) {
        this.colorApp = 'theme-7'
      } else if (this.$store.state.selected_store.setting.online_color_id === 8) {
        this.colorApp = 'theme-8'
      }
      const colorTheme = this.$store.state.selected_store.setting.online_color
      const colorApp = colorTheme.split(',')
      if (colorApp) {
        this.$vuetify.theme.themes.light.primary = colorApp[0]
        this.$vuetify.theme.themes.dark.primary = colorApp[0]
      } else {
        this.$vuetify.theme.themes.light.primary = '#38B8FF'
        this.$vuetify.theme.themes.dark.primary = '#38B8FF'
      }
    }

    document.addEventListener('swUpdated', this.showRefreshUI, { once: true })
    // Refresh all open app tabs when a new service worker is installed.
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return
      this.refreshing = true
      window.location.reload()
    })
  },
  methods: {
    showRefreshUI(e) {
      // Display a snackbar inviting the user to refresh/reload the app due
      // to an app update being available.
      // The new service worker is installed, but not yet active.
      // Store the ServiceWorkerRegistration instance for later use.
      this.registration = e.detail
      this.snackWithButtons = true
    },
    refreshApp() {
      this.snackWithButtons = false
      // Protect against missing registration.waiting.
      if (!this.registration || !this.registration.waiting) { return }
      this.registration.waiting.postMessage('skipWaiting')
    },
    closeSheetNoAccessGPS() {
      this.$store.state.block_location = false
    },
    closeSheetNoAccessCamera() {
      this.$store.state.block_camera = false
    },
    closeSheetOutsideRadius() {
      this.$store.state.outside_radius = false
      // this.$router.push({ name: 'listoutlets' }).catch(() => {})
    },
    goLearnMore() {
      this.$router.push({ name: 'learn_more' }).catch(() => {})
      this.$store.state.block_camera = false
      this.$store.state.block_location = false
      this.$store.state.block_tooLong = false
    },
    goBackHome() {
      this.$store.state.block_tooLong = false
      const astra_outlet = this.$store.state.store_astra
      const tmii_outlet = this.$store.state.store_tmii
      const url_id = this.$store.state.url_domain

      if (tmii_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://order.kulinertmii.id'
      } else if (astra_outlet.indexOf(url_id) !== -1) {
        window.location.href = 'https://zestloungemenaraastra.myolsera.com'
      } else {
        this.$router.push({ name: 'home' }).catch(() => {})
      }
    }
  },
  head: {
    title: function() {
      return {
        inner: this.title,
        separator: ' - ',
        complement: 'Pesan Online'
      }
    },
    link: function() {
      return [
        { rel: 'icon', type: 'image/png', sizes: '16x16', href: this.favicon },
        { rel: 'icon', type: 'image/png', sizes: '32x32', href: this.favicon },
        { rel: 'shorcut icon', type: 'image/png', sizes: '16x16', href: this.favicon },
        { rel: 'shorcut icon', type: 'image/png', sizes: '32x32', href: this.favicon }
      ]
    }
  }
}
</script>
<style>
  @import '../../../assets/sass/app.scss';
  @import '../../../assets/custom/style.scss';
</style>
